import { NavToLink } from "../components/Tools/FileDownloadHelper";

export interface SupportedDocuments {
    peppolIdentifier: string,
    documentTypes: string[],
    canReceiveInvoices: boolean,
    canReceiveCreditNotes: boolean,
    canReceiveMLR: boolean,
    canReceiveInvoiceResponse: boolean,
}
export type DigitealEnv = "Test" | "Prod";

export const SupportedDocument = async (token: string, peppolIdentifier: string, env: DigitealEnv): Promise<SupportedDocuments | undefined | null> => {
    if (!peppolIdentifier || !token) return null;

    return fetch(`api/PeppolDirectory/` + peppolIdentifier + "/SupportedDocument/" + env, {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            authorization: "bearer " + token,
        },
        mode: "cors",
        cache: "default",
    })
        .then(response => {
            if (response.status === 403) {
                return null;
            }
            else if (response.status === 404 || response.status === 204) {
                return undefined;
            }
            return response.json() as Promise<SupportedDocuments>;
        })
        .then(data => {
            console.log("SupportedDocument", data);
            return data;
        });
};

export const GotoDirectoryPeppolWeb = async (peppolIdentifier: string) => {
    const pi = peppolIdentifier.replace(":", "%3A");
    const Link = "https://directory.peppol.eu/public/locale-en_US/menuitem-search?q=" + pi;
    NavToLink(Link);
};